import { ReactNode } from 'react';

export function DetailListItem({ label, children }: { label: string; children: ReactNode }) {
  return (
    <dl className="p-3">
      <dt className="text-xs font-sans text-darkgray">{label}</dt>
      <dd className="text-sm font-sans text-black mt-1">{children}</dd>
    </dl>
  );
}
